import React, { useEffect } from 'react'
import { useGetAuthenticatedUser } from '../../Flux/Selector/index.js'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { tracingAxios } from '../../Repository/Sentry.js'
import { Environment } from '../../environment.js'
import { addMessage } from '../../Flux/Slice/Application/ApplicationSlice.js'
import { errorMessage, successMessage } from '../../Model/Message/IMessage.js'
import type { BaseModalProps } from '../Modal/BaseModal.js'
import { BaseModal } from '../Modal/BaseModal.js'
import { localStorageKeyRedirectAfterRegister } from '../Layout/PageLayout/PageLoadHooks.js'

export const WelcomeFreshUser: React.FC<BaseModalProps> = (props) => {
  const user = useGetAuthenticatedUser()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (!user?.org?.isPending) {
      props.onClose()
    }
  }, [user])

  const handleClose = async () => {
    try {
      props.onClose()
      await tracingAxios.put(`${Environment.API_URL}/api/registration/first-login`, {}, { withCredentials: true })
      dispatch(addMessage(successMessage('Welcome finalized!')))

      const redirectUrl = localStorage.getItem(localStorageKeyRedirectAfterRegister)
      if (redirectUrl) {
        localStorage.removeItem(localStorageKeyRedirectAfterRegister)
        navigate(redirectUrl)
      } else if (user?.org?.isBillingMissing) {
        navigate('/billing')
      }
    } catch (e) {
      console.error('error finalizing registration', e)
      dispatch(addMessage(errorMessage('Could not finalize registration. Please contact support.')))
    }
  }

  return (
    <BaseModal isOpen={props.isOpen} onClose={props.onClose} className="modal">
      <div className="modal-box w-full max-w-3xl max-h-[90vh] min-h-[50vh] flex flex-col justify-between p-6">
        <div>
          <h3 className="text-2xl font-bold text-center text-primary mb-4">Welcome to Spcfy!</h3>
          <p className="text-base mb-4">We&#39;re excited to have you onboard. Your organization has been registered and fully setup.</p>
          <p className="text-base mb-2">
            To get started, check out the <strong>Help</strong> section from the main menu. You can upload your organization&#39;s logo and
            customize your profile by visiting the <strong>Organization Settings</strong> in the top right corner.
          </p>
          <p className="text-base">If you have questions or need help, feel free to reach out via our support channel.</p>
          {user?.org?.isBillingMissing && (
            <p className="text-base mt-4">
              To start submitting orders, head to the <strong>Billing</strong> section to choose a subscription plan.
          </p>
          )}
        </div>

        <div className="modal-action mt-8">
          <button className="btn btn-primary w-full sm:w-auto" onClick={handleClose}>
            Let&#39;s Go
          </button>
        </div>
      </div>
    </BaseModal>
  )
}
